@file:OptIn(InternalResourceApi::class)

package linx.linxapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/linx.linxapp.generated.resources/"

@delegate:ResourceContentHash(-1_654_144_737)
internal val Res.drawable.american_express_svgrepo_com: DrawableResource by lazy {
      DrawableResource("drawable:american_express_svgrepo_com", setOf(
        ResourceItem(setOf(), "${MD}drawable/american_express_svgrepo_com.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(82_121_622)
internal val Res.drawable.app_icon: DrawableResource by lazy {
      DrawableResource("drawable:app_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/app_icon.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-913_901_146)
internal val Res.drawable.coffee_shop: DrawableResource by lazy {
      DrawableResource("drawable:coffee_shop", setOf(
        ResourceItem(setOf(), "${MD}drawable/coffee_shop.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_610_308_674)
internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(986_910_537)
internal val Res.drawable.former_visa__company__logo: DrawableResource by lazy {
      DrawableResource("drawable:former_visa__company__logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/former_visa__company__logo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_920_296_110)
internal val Res.drawable.ic_android_black_24dp: DrawableResource by lazy {
      DrawableResource("drawable:ic_android_black_24dp", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_android_black_24dp.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_085_382_779)
internal val Res.drawable.mastercard_light: DrawableResource by lazy {
      DrawableResource("drawable:mastercard_light", setOf(
        ResourceItem(setOf(), "${MD}drawable/mastercard_light.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-956_606_187)
internal val Res.drawable.primary_logo_final: DrawableResource by lazy {
      DrawableResource("drawable:primary_logo_final", setOf(
        ResourceItem(setOf(), "${MD}drawable/primary_logo_final.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_528_039_202)
internal val Res.drawable.thumb_nail_up: DrawableResource by lazy {
      DrawableResource("drawable:thumb_nail_up", setOf(
        ResourceItem(setOf(), "${MD}drawable/thumb_nail_up.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_415_896_098)
internal val Res.drawable.us: DrawableResource by lazy {
      DrawableResource("drawable:us", setOf(
        ResourceItem(setOf(), "${MD}drawable/us.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(219_929_539)
internal val Res.drawable.visa_color: DrawableResource by lazy {
      DrawableResource("drawable:visa_color", setOf(
        ResourceItem(setOf(), "${MD}drawable/visa_color.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("american_express_svgrepo_com", Res.drawable.american_express_svgrepo_com)
  map.put("app_icon", Res.drawable.app_icon)
  map.put("coffee_shop", Res.drawable.coffee_shop)
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("former_visa__company__logo", Res.drawable.former_visa__company__logo)
  map.put("ic_android_black_24dp", Res.drawable.ic_android_black_24dp)
  map.put("mastercard_light", Res.drawable.mastercard_light)
  map.put("primary_logo_final", Res.drawable.primary_logo_final)
  map.put("thumb_nail_up", Res.drawable.thumb_nail_up)
  map.put("us", Res.drawable.us)
  map.put("visa_color", Res.drawable.visa_color)
}
